import { DialogService } from './../../../shared/services/dialog.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MdInputModule, MdRadioModule, MdDialog, MdDialogRef, MD_DIALOG_DATA, MdSelectModule } from '@angular/material';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { Utility } from '../../../common/utility';
import { NewVaccineAddedModel, VaccineCourseStatus } from '../../../models/consultation-process/previous-vaccine.model';
import { ValidationService } from '../../../shared/services/validation.service';
import { PreviousVaccineService } from '../../consultation-process/record-previous-vaccines/record-previous-vaccine.service';

@Component({
  selector: 'add-vaccination-popup',
  templateUrl: 'add-vaccination-popup.component.html',
  providers: [PreviousVaccineService]
})

export class AddVaccinationPopupComponent implements OnInit {
  public newDiseaseForm: FormGroup;
  public klass = 'newVaccinePopupComponent';
  public listDisease: Array<any> = null;
  public newVaccineAdded: Array<NewVaccineAddedModel> = [];
  public vaccines: Array<{
    id: string,
    name: string,
    monthExpectedCover: number
  }> = [];

  public centres: Array<any> = [];
  public lastVaccine: string;
  constructor(public dialogRef: MdDialogRef<AddVaccinationPopupComponent>,
    public formBuilder: FormBuilder,
    public utility: Utility,
    public previousVaccineService: PreviousVaccineService,
    public dialogService: DialogService,
    @Inject(MD_DIALOG_DATA) public data: any) {
    this.createForm();
  }

  ngOnInit() {
    this.previousVaccineService.getDisease().subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.listDisease = data;
        }
      }
    );

    this.previousVaccineService.getOtherCentre().subscribe(
      (result) => {
        if (result) {
          this.centres = result.json();
        }
      }
    );
  }

  createForm() {
    this.newDiseaseForm = this.formBuilder.group({
      diseaseId: ['', [Validators.required]],
      completion: [null, [Validators.required]],
      administeredDate: [null, [Validators.required, ValidationService.isValidDateOfAdministeredDate]],
      expireDate: [null],
      centre: ['', [Validators.required]],
      sourceType: [null, [Validators.required]],
      vaccineId: [null, [Validators.required]]
    });
  }

  /**
   * load new vaccine base on selected disease
   * @param event
   */
  onCheckVaccinesRelatedToDisease(diseaseCtrl: FormControl) {
    if (diseaseCtrl.value) {
      // get vaccine by disease
      this.previousVaccineService.getVaccineByDiseaseId(this.newDiseaseForm.value.diseaseId).subscribe(
        (result) => {
          if (result) {
            this.vaccines = result.json();
          }
        }
      );
      this.newDiseaseForm.controls['vaccineId'].setValue(null);
      if (this.newDiseaseForm.controls['completion'].value === 'incomplete') {
        this.newDiseaseForm.controls['expireDate'].setValue(null);
        this.newDiseaseForm.controls['expireDate'].markAsUntouched();
      }
      // this.newDiseaseForm.controls['administeredDate'].setValue(null);
      this.newDiseaseForm.controls['vaccineId'].markAsUntouched();
      // this.newDiseaseForm.controls['administeredDate'].markAsUntouched();
    } else {
      this.vaccines = [];
    }
  }

  getVaccineData() {
    const data: NewVaccineAddedModel = {
      diseaseId: this.newDiseaseForm.value.diseaseId,
      isCourseCompleted: (this.newDiseaseForm.value.completion === VaccineCourseStatus.complete) ? true : false,
      dateAdministered: this.utility.convertDateToString(this.newDiseaseForm.value.administeredDate),
      otherCentreId: this.newDiseaseForm.value.centre,
      vaccineId: this.newDiseaseForm.value.vaccineId,
      isVerbalSource: this.newDiseaseForm.value.sourceType
    };
    return data;
  }

  onChangeVaccine() {
    this.calculateExpiredDate();
  }

  calculateExpiredDate() {
    if (this.newDiseaseForm.controls['diseaseId'].value !== null &&
      this.newDiseaseForm.controls['administeredDate'].value !== null) {
      const tempTime = this.newDiseaseForm.controls['administeredDate'].value;
      if (tempTime) {
        const administeredGetMonth = tempTime.getMonth();
        const vaccineInfo = this.vaccines.filter(v => v.id === this.newDiseaseForm.controls['vaccineId'].value);
        if (vaccineInfo.length > 0) {
          const numberMonths = tempTime.getMonth() + vaccineInfo[0].monthExpectedCover;
          let temp = new Date(tempTime);
          temp.setMonth(numberMonths);
          this.newDiseaseForm.controls['expireDate'].setValue(temp);
        }
      }
    }
  }

  onDateChange(event) {
    // ValidationService.validationDate(this.newDiseaseForm.controls['administeredDate'], event);
    this.calculateExpiredDate();
  }

  onSubmit(isClose) {
    this.markAsTouch();
    if (this.newDiseaseForm.valid) {
      const submitData = this.getVaccineData();
      submitData['isFromConsultationHistory'] = true;
      this.previousVaccineService.updatePreviousVaccine(this.data.id, this.data.patientId, submitData).subscribe(
        (result) => {
          const data = result.json();
          if (isClose) {
            this.dialogService.openSuccessDialog({ message: data.message });
            this.onCloseDialog();
          } else {
            this.lastVaccine = this.vaccines.find(x => x.id === this.newDiseaseForm.controls['vaccineId'].value).name.toString() +
              ' has been added successfully.';
            // CR01: clear date administered, date expired
            this.newDiseaseForm.controls['vaccineId'].setValue(null);
            this.newDiseaseForm.controls['administeredDate'].setValue(null);
            this.newDiseaseForm.controls['expireDate'].setValue(null);

            this.newDiseaseForm.controls['vaccineId'].markAsUntouched();
            this.newDiseaseForm.controls['administeredDate'].markAsUntouched();
            this.newDiseaseForm.controls['expireDate'].markAsUntouched();
          }
        });
    }
  }

  onCloseDialog() {
    this.dialogRef.close();
  }

  markAsTouch() {
    for (const key in this.newDiseaseForm.controls) {
      if (this.newDiseaseForm.controls.hasOwnProperty(key)) {
        this.newDiseaseForm.controls[key].markAsTouched();
        this.newDiseaseForm.controls[key].updateValueAndValidity();
      }
    }
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-history/vaccination/add-vaccination-popup.component.ts